import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=2ff3d980"
import script from "./page-list.vue?vue&type=script&lang=ts"
export * from "./page-list.vue?vue&type=script&lang=ts"
import style0 from "./page-list.vue?vue&type=style&index=0&id=2ff3d980&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports